import React from 'react'
import { history } from '../store'

class ObjectiveList extends React.Component {
  goTo(customer, year, e) {
    history.push(`/objectives/${customer}?year=${year}`)
  }

  progressBar(actual, objective) {

    const percentage = objective > 0 ? (actual / objective) * 100 : 0;
    const barWidth = Math.min(percentage, 100);

    let color = "warning"

    if (percentage < 50) {
      color = "danger"
    } else if (percentage >= 100) {
      color = "success"
    }

    return (
      <div className="obj-progress-container">
        <div className={`obj-progress-bar ${color}`} style={{ width: `${barWidth}%` }}></div>
        <div className="obj-progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  calculateTotalObjective(objective) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let totalObjectives = 0;

    {
      months.map((month) => {
        weeks.map(week => (
          totalObjectives += objective[month][week]
        ))
      })
    }

    return totalObjectives
  }

  calculateTotalReal(objective) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => arqueo.Customer._id === objective.Customer._id);

    let totalReal = 0;

    filteredArqueos.map((arqueo) => {
      if (arqueo.ContractType != "SALE") {
        totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax)
      }
    })

    return totalReal
  }

  calculateTotalKPILay(objective) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => arqueo.Customer._id === objective.Customer._id);

    let totalPack = 0;
    let totalLay = 0;

    filteredArqueos.map((arqueo) => {
      totalLay += arqueo.Items.VWLAY
      totalPack += arqueo.Items.VWPACK
    })

    return (totalLay / totalPack) * 100
  }

  calculateTotalKPIGo(objective) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => arqueo.Customer._id === objective.Customer._id);

    let totalPack = 0;
    let totalGo = 0;

    filteredArqueos.map((arqueo) => {
      totalGo += arqueo.Items.VWGO
      totalPack += arqueo.Items.VWPACK
    })

    return (totalGo / totalPack) * 100
  }

  calculateTotalCrossSale(objective) {

    const filteredArqueos = this.props.arqueos.filter(arqueo => arqueo.Customer._id === objective.Customer._id);

    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    filteredArqueos.map((arqueo) => {
      totalLay += arqueo.Items.VWLAY
      totalGo += arqueo.Items.VWGO
      totalPack += arqueo.Items.VWPACK
    })

    return ((totalGo + totalLay) / totalPack) * 100
  }

  calculatePriceWithoutTax(priceWithTax, taxRate) {
    const taxMultiplier = 1 + taxRate / 100;
    const priceWithoutTax = (priceWithTax / taxMultiplier).toFixed(2);
    return parseFloat(priceWithoutTax);
  }

  render() {
    const sortedObjectives = [...this.props.objectives].sort((a, b) =>
      a.Customer.Fullname.localeCompare(b.Customer.Fullname)
    );

    return (
      <>
        {/* Desktop list header */}
        <div className="obj-admin-list-header" style={{ gridTemplateColumns: 'unset' }}>
          <div className="obj-header-col col-customer">Cliente</div>
          <div className="obj-header-col col-year">Año</div>
          <div className="obj-header-col col-real">Real</div>
          <div className="obj-header-col col-objective">Objetivo</div>
          <div className="obj-header-col col-progress">Progreso</div>
          <div className="obj-header-col" style={{ width: '100px', textAlign: 'center' }}>KPI Lay</div>
          <div className="obj-header-col" style={{ width: '100px', textAlign: 'center' }}>KPI Go</div>
          <div className="obj-header-col" style={{ width: '160px', textAlign: 'center' }}>Venta Cruzada</div>
        </div>

        {/* Card list */}
        <div className="obj-admin-objective-list">
          {sortedObjectives.map(objective => {
            const date = (new Date(objective.TimeStamp)).getFullYear()
            const totalReal = this.calculateTotalReal(objective)
            const totalObjective = this.calculateTotalObjective(objective)
            const kpiLay = this.calculateTotalKPILay(objective)
            const kpiGo = this.calculateTotalKPIGo(objective)
            const crossSale = this.calculateTotalCrossSale(objective)

            return (
              <div key={objective.number}
                className="obj-admin-objective-card"
                onClick={e => this.goTo(objective.Customer._id, date, e)}>
                <div className="obj-admin-objective-row">
                  <div className="obj-admin-col col-customer">
                    <span className="obj-customer-name">{objective.Customer.Fullname}</span>
                  </div>
                  <div className="obj-admin-col col-year">{date}</div>
                  <div className="obj-admin-col col-real">{totalReal.toFixed(2)} €</div>
                  <div className="obj-admin-col col-objective">{totalObjective.toFixed(2)} €</div>
                  <div className="obj-admin-col col-progress">{this.progressBar(totalReal, totalObjective)}</div>
                  <div className="obj-admin-col" style={{ width: '100px', textAlign: 'center' }}>
                    {isNaN(kpiLay) ? '—' : kpiLay.toFixed(2) + '%'}
                  </div>
                  <div className="obj-admin-col" style={{ width: '100px', textAlign: 'center' }}>
                    {isNaN(kpiGo) ? '—' : kpiGo.toFixed(2) + '%'}
                  </div>
                  <div className="obj-admin-col" style={{ width: '160px' }}>
                    {this.progressBar(crossSale, 100)}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </>
    )
  }
}

export default ObjectiveList

